import $ from 'jquery';
import _ from 'underscore';

$.fn.serializeObject = function () {
	const o = {};
	const a = this.serializeArray();
	$.each(a, function () {
		if (o[this.name] !== undefined) { // eslint-disable-line
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(_.escape(this.value) || '');
		} else {
			o[this.name] = _.escape(this.value) || '';
		}
	});
	return o;
};



/** WEBPACK FOOTER **
 ** ./app/scripts/util/form/serializeObject.js
 **/